<template>
    <div v-if="item.unitd_price && item.unitd_qty" :class="mode == 'cp-unit' ? 'cp-unit-desc' : 'cd-tax cd-unit-desc'">
        <BaseCmsLabel code="price_for" />
        <template v-if="item.unitd_description"> {{' '+item.unitd_description+': '}}</template>
        <template v-else-if="unit[1]">{{' '+unit[1]+': '}}</template>
        <BaseUtilsFormatCurrency :price="item.unitd_price" /> / {{unit[1] || item.unitd_qty}}
    </div>
</template>

<script setup>
    const props = defineProps(['item','mode']);
    const unit = computed(() => (props.item.unitd_qty ? props.item.unitd_qty.split('/') : ['', '']));
</script>
